// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCategories_root__1snGv","rootRent":"IconCategories_rootRent__1zIuW","fillColor":"IconCategories_fillColor__3t3lD"};